import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ErrorView } from './ErrorView'
import { CatchErrorProvider } from './hooks/useCatchError'
import { RootState } from './redux/store'

type State = {
    hasError: boolean
    error?: Error
}

function mapStateToProps(state: RootState) {
    return {
        state
    }
}

const connector = connect(mapStateToProps)
type Props = ConnectedProps<typeof connector>

class ErrorBoundary_ extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = { hasError: false, error: undefined }
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    public componentDidCatch(error: Error) {
        this.setError(error)
    }

    private setError(error: Error) {
        // TODO: This is your chance to phone-home
        console.error(error)

        this.setState(() => ({
            error,
            hasError: true
        }))
    }

    public render() {
        if (this.state.hasError === false) {
            return (
                <CatchErrorProvider
                    value={{
                        setError: (error) => { this.setError(error) }
                    }}
                >
                    {this.props.children}
                </CatchErrorProvider>
            )
        }

        return (
            <ErrorView
                message={this.state.error?.message ?? "Unknown error"}
                stack={this.state.error?.stack ?? undefined}
                state={this.props.state}
            />
        )
    }

}

// TODO: There's something stupid going on here with the typing. If we
// don't export this as 'any', the compiler complains, cba to waste
// any time on this.
export const ErrorBoundary = connector(ErrorBoundary_) as any
